module.exports = __webpack_public_path__ + "img/tubiao203.84cb6db4.png";